export default __webpack_public_path__ + "user_profile_top_nav.png";